<template>
    <div>
        <div class="card card-default bg-transparent shadow-none mb-2" >
            <div class="border-b-2 border-followup-nav text-sm text-grey-darkest py-2 pl-4">
                Calendar Sync
            </div>
            <div class="card-body">
                <div class="row py-4">
                    <div v-if="user.external_email !== null" class="w-full px-3">
                        <div class="d-flex align-items-center mb-3">
                            <div class="float-left mr-3 text-sm text-grey-darkest text-right" style="width: 100%; max-width: 170px;">
                                Sync Status
                            </div>
                            <div class="w-auto float-left mr-3 d-flex align-items-center h-100">
                                <span v-if="alreadySynced" style="color: #01b1af">Success!</span>
                                <span v-else style="color: #af0303">Not Synced</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="float-left mr-3 text-sm text-grey-darkest text-right" style="width: 100%; max-width: 170px;">
                                Synced Email
                            </div>
                            <div class="w-auto float-left mr-3 d-flex align-items-center h-100">
                                <input type="text" :value="user.external_email" class="form-control bg-transparent border-1 text-sm text-grey-dark shadow-none border-grey min-width-custom-calendar custom-calendar-input-padding" readonly>
                            </div>
                            <div class="w-auto float-left mr-3 d-flex align-items-center h-100">
                                <a href="javascript:void(0)" id="change-connected-email" name="change-connected-email"
                                        @click="connectExternalMail()"
                                        class="underline text-black text-sm mr-4">
                                    Change Connected Email
                                </a>
                                <a href="javascript:void(0)" id="change-connected-email" name="change-connected-email"
                                   @click="reauthenticateUser()"
                                   class="underline text-black text-sm" data-toggle="tooltip" data-placement="top" title="If you face any issue using calendar sync functionality, please re-authenticate your email">
                                    Re-Authenticate Email
                                </a>
                            </div>
                        </div>
                        <div class="d-flex align-items-center mt-3">
                            <div class="float-left mr-3 text-sm text-grey-darkest text-right" style="width: 100%; max-width: 170px;">
                                Select Calendar
                            </div>
                            <div class="min-width-custom-calendar">
                                <multiselect :options="allCalendars"
                                             v-model="selectedCalendar"
                                             :show-labels="false"
                                             track-by="name"
                                             label="name"
                                             :multiple=false
                                             :searchable=true
                                             @select="checkSelectedCalendar()"
                                             wrapper-class="form-control bg-transparent border-1 text-sm text-grey-dark shadow-none border-grey cursor-pointer min-width-custom-calendar">
                                </multiselect>
                            </div>
                        </div>
                        <div class="d-flex align-items-center mt-3">
                            <div class="float-left mr-3 text-sm text-grey-darkest text-right" style="width: 100%; max-width: 170px;">
                                Calendar Event Subject For Sales Activity
                            </div>
                            <div class="min-width-custom-calendar">
                                <multiselect :options="salesActivitySubjectOptions"
                                             v-model="selectedSalesActivitySubjectOptions"
                                             :show-labels=true
                                             track-by="name"
                                             label="name"
                                             :multiple=true
                                             :searchable=true
                                             class="mb-2 cursor-pointer">
                                </multiselect>
                            </div>
                            <small class="ml-3">* If no option is selected only project name is pushed to the event as subject</small>
                        </div>
                        <div class="d-flex align-items-center mt-3">
                            <div class="float-left mr-3 text-sm text-grey-darkest text-right" style="width: 100%; max-width: 170px;">
                                Calendar Event Subject For Contact Activity
                            </div>
                            <div class="min-width-custom-calendar">
                                <multiselect :options="contactActivitySubjectOptions"
                                             v-model="selectedContactActivitySubjectOptions"
                                             :show-labels=true
                                             track-by="name"
                                             label="name"
                                             :multiple=true
                                             :searchable=true
                                             class="mb-2 cursor-pointer">
                                </multiselect>
                            </div>
                            <small class="ml-3">* If no option is selected only contact name is pushed to the event as subject</small>
                        </div>
                        <div class="d-flex align-items-center mt-3">
                            <div class="float-left mr-3 text-sm text-grey-darkest text-right" style="width: 100%; max-width: 170px;">
                                Calendar Event Subject For Bid Date
                            </div>
                            <div class="min-width-custom-calendar">
                                <multiselect :options="bidDateSubjectOption"
                                             v-model="selectedBidDateSubjectOption"
                                             :show-labels=true
                                             track-by="name"
                                             label="name"
                                             :multiple=true
                                             :searchable=true
                                             class="mb-2 cursor-pointer">
                                </multiselect>
                            </div>
                            <small class="ml-3">* If no option is selected only project name and "bid date" is pushed to the event as subject</small>
                        </div>
                        <div class="d-flex align-items-center mt-3">
                            <div class="float-left mr-3 text-sm text-grey-darkest text-right" style="width: 100%; max-width: 170px;">
                                Calendar Event Subject For Pre Bid Date
                            </div>
                            <div class="min-width-custom-calendar">
                                <multiselect :options="preBidDateSubjectOption"
                                             v-model="selectedPreBidDateSubjectOption"
                                             :show-labels=true
                                             track-by="name"
                                             label="name"
                                             :multiple=true
                                             :searchable=true
                                             class="mb-2 cursor-pointer">
                                </multiselect>
                            </div>
                            <small class="ml-3">* If no option is selected only project name and "pre bid date" is pushed to the event as subject</small>
                        </div>
                    </div>
                    <div v-else class="my-4">
                        <div class="row">
                            <div class="col-md-2">
                            </div>
                            <div class="col-md-8">
                                <p class="text-sm text-black font-weight-light">
                                    Your external e-mail isn't connected to FollowUp CRM.
                                    <br>
                                    <br>
                                    Sync external e-mail first under External E-mail in the User Profile tab of Your Settings. Click on the Sync E-mail button below to go there now. Come back to this tab after syncing e-mail to sync your calendar
                                </p>
                                <br>
                                <button type="button" id="connect-external-mail" name="connect-external-mail"
                                        @click="connectExternalMail()"
                                        class="btn btn-primary rounded-lg mb-2">
                                    Sync External E-mail
                                </button>
                            </div>
                            <div class="col-md-2">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-default bg-transparent shadow-none" v-if="selectedCalendar">
            <div class="border-b-2 border-followup-nav text-sm text-grey-darkest py-2 pl-4">
                Choose Activities to Sync
            </div>
            <div class="card-body">
                <div class="row py-4">
                    <div class="w-full px-3">
<!--                        <div class="row">-->
<!--                            <div class="col-12 text-black mb-3 pl-5 font-weight-light">-->
<!--                                Bid Dates (Filter)<i class="fa fa-info-circle makeItTooltip ml-1 cursor-pointer text-primary" aria-hidden="true" title="These filters are used for project sales activities. Project with checked date is pushed if the checked date is filled in that project."></i>-->
<!--                            </div>-->
<!--                            <div class="row w-100">-->
<!--                                <div class="col-1"></div>-->
<!--                                <div class="col-10">-->
<!--                                    <b-form-group v-slot="{ ariaDescribedbyFilters }">-->
<!--                                        <b-form-checkbox-group-->
<!--                                            id="checkbox-group-3"-->
<!--                                            v-model="selectedBidDate"-->
<!--                                            :options="bidDatesOptions"-->
<!--                                            :aria-describedby="ariaDescribedbyFilters"-->
<!--                                            name="flavour-3"-->
<!--                                            class="text-black text-sm custom-calendar-checkbox"-->
<!--                                        ></b-form-checkbox-group>-->
<!--                                    </b-form-group>-->
<!--                                </div>-->
<!--                                <div class="col-1"></div>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="row">
                            <div class="col-12 text-black mb-3 pl-5 font-weight-light">
                                Bid Dates <i class="fa fa-info-circle makeItTooltip ml-1 cursor-pointer text-primary" title="Value of checked date will be synced with external calendar" aria-hidden="true"></i>
                            </div>
                            <div class="row w-100">
                                <div class="col-1"></div>
                                <div class="col-10">
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-checkbox-group
                                            id="checkbox-group-13"
                                            v-model="selectedBidDateArray"
                                            :options="bidDatesOptions"
                                            :aria-describedby="ariaDescribedby"
                                            name="flavour-3"
                                            class="text-black text-sm custom-calendar-checkbox"
                                        ></b-form-checkbox-group>
                                    </b-form-group>
                                </div>
                                <div class="col-1"></div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-12 text-black mb-3 pl-5 font-weight-light">
                                Sales Activities
                            </div>
                            <div class="row">
                                <div class="col-1"></div>
                                <div class="col-10">
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-checkbox-group
                                            id="checkbox-group-1"
                                            v-model="selectedSalesValue"
                                            :options="selectedSalesBehaviourOptions"
                                            :aria-describedby="ariaDescribedby"
                                            name="flavour-1"
                                            class="text-black text-sm custom-calendar-checkbox"
                                        ></b-form-checkbox-group>
                                    </b-form-group>
                                </div>
                                <div class="col-1"></div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-12 text-black mb-3 pl-5 font-weight-light">
                                Contact Activities
                            </div>
                            <div class="row w-full">
                                <div class="col-1"></div>
                                <div class="col-10">
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-checkbox-group
                                            id="checkbox-group-2"
                                            v-model="selectedContactValue"
                                            :options="selectedContactBehaviourOptions"
                                            :aria-describedby="ariaDescribedby"
                                            name="flavour-2"
                                            class="text-black text-sm custom-calendar-checkbox"
                                        ></b-form-checkbox-group>
                                    </b-form-group>
                                </div>
                                <div class="col-1"></div>
                            </div>
                        </div>
                        <div class="text-right mt-3">
                            <div class="mb-2 text-right" v-if="checkUserCalendar">
                                <div v-if="alreadySynced">
                                    Last Synced <span style="color: #01b1af">{{lastSynced}}</span>
                                </div>
                                <div v-else>
                                    <span style="color: red;">Selected calendar is not synced</span>
                                </div>
                            </div>
                            <button v-if="alreadySynced" type="button" id="save-event-subjects"
                                    name="save-event-subjects"
                                    @click="unsyncCalendarSettings(1)"
                                    class="btn btn-outline-danger rounded-lg mb-2 mr-2 text-red-dark">
                                <i v-if="unsyncIcon" class="fa fa-spin fa-spinner text-red-dark"
                                   aria-hidden="true"></i> <span v-if="!unsyncIcon">Unsync Calendar</span><span v-else>Unsyncing Calendar</span>
                            </button>
                            <button v-if="alreadySynced" type="button" id="save-event-subjects"
                                    name="save-event-subjects"
                                    @click="unsyncCalendarSettings(0)"
                                    class="btn btn-outline-danger rounded-lg mb-2 mr-2 text-red-dark">
                                <i v-if="unsyncIcon" class="fa fa-spin fa-spinner text-red-dark"
                                   aria-hidden="true"></i> <span v-if="!unsyncIcon">Unsync & Disconnect Calendar</span><span v-else>Unsyncing & Disconnecting Calendar</span>
                            </button>
                            <button type="button" id="save-event-subjects"
                                    name="save-event-subjects"
                                    @click="saveCalendarSettings()"
                                    class="btn btn-primary rounded-lg mb-2 mr-2">
                                Save Calendar Settings
                            </button>
                            <button type="button" id="change-connected-email"
                                    name="change-connected-email"
                                    @click="syncCalendar()"
                                    class="btn btn-primary rounded-lg mb-2"
                                    v-if="checkUserCalendar">
                                <i v-if="syncIcon" class="fa fa-spin fa-spinner text-white"
                                   aria-hidden="true"></i> <span v-if="!syncIcon">Sync Now</span><span v-else>Syncing</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import axios from 'axios';
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";

export default {
    name: 'calendar-sync',
    props: ['user'],
    components: {Multiselect},
    data() {
        return {
            allCalendars: [],
            selectedCalendar: null,
            selectedSalesBehaviourOptions: [],
            selectedSalesValue: [],
            checkUserCalendar: false,
            alreadySynced: false,
            lastSynced: '',
            selectedContactBehaviourOptions: [],
            selectedContactValue: [],
            syncIcon: false,
            salesActivitySubjectOptions: [],
            selectedSalesActivitySubjectOptions: [],
            contactActivitySubjectOptions: [],
            selectedContactActivitySubjectOptions: [],
            bidDatesOptions: [
                {
                    'text': 'Bid Date',
                    'value': 'bid-date'
                },
                {
                    'text': 'Pre Bid Date',
                    'value': 'pre-bid-date'
                }
            ],
            selectedBidDate: [],
            unsyncIcon: false,
            selectedBidDateArray: [],
            bidDateSubjectOption: [],
            selectedBidDateSubjectOption: [],
            preBidDateSubjectOption: [],
            selectedPreBidDateSubjectOption: [],
        }
    },
    created() {

    },
    mounted() {
        if(this.user.external_email_service){
            this.getUserCalendar();
        }
        this.getSalesBehaviourList();
        this.getContactSalesBehaviors();
        this.getEventSubject();
        this.makeItToolTip();

    },
    methods: {
        connectExternalMail(){
            window.location.href = '/settings#/profile'
        },
        getUserCalendar(){
            axios.post(route('calendar.get-user-calendars')).then((response) => {
                this.allCalendars = response.data;
                if(this.user.selected_calendar_id){
                    response.data.forEach(item => {
                        if(item.id == this.user.selected_calendar_id){
                            this.selectedCalendar = {
                                'id': item.id,
                                'name': item.name
                            };
                            this.checkSelectedCalendar('getUserCalendar');
                        }
                    });
                }
            });
        },
        getSalesBehaviourList() {
            axios.get(route('settings.sales-behavior.for-calendar-sync')).then((response) => {
                let tempSalesBehaviourOptions = response.data.map(salesBehaviorObj => {
                    if(salesBehaviorObj.id !== -1){
                        return ({
                            value: salesBehaviorObj.id,
                            text: salesBehaviorObj.name,
                            color: 'red'
                        });
                    }
                });
                this.selectedSalesBehaviourOptions = tempSalesBehaviourOptions.filter((item) => (item !== undefined));
            });
        },
        checkSelectedCalendar(from = null){
            this.$nextTick(() => {
                axios.post(route('calendar.check-user-calendar'), {calendar: this.selectedCalendar}).then((response) => {
                    if(!from){
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }
                    if(response.data.calendar !== null){
                     this.lastSynced = moment.utc(response.data.calendar.last_sync).local().format('MM/DD/YYYY hh:mm A');
                     this.alreadySynced = true;
                    }else{
                        this.alreadySynced = false;
                    }
                    this.checkUserCalendar = true;
                });
            });
        },
        syncCalendar(){
            if(this.selectedSalesValue.length == 0 && this.selectedContactValue.length == 0 && this.selectedBidDateArray.length == 0){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select sales activity or contact  or bid dates'
                });
                return false;
            }
            this.saveCalendarSettings('syncCalendar');
            this.syncIcon = true;
            let userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let userTimeZoneOffset = new Date().getTimezoneOffset();
            axios.post(route('calendar.sync-calendar'), {
                calendar: this.selectedCalendar,
                salesActivity: this.selectedSalesValue,
                userTimeZoneName: userTimeZoneName,
                userTimeZoneOffset: userTimeZoneOffset,
                contactActivity:this.selectedContactValue,
                selectedSalesActivitySubjectOptions: this.selectedSalesActivitySubjectOptions,
                selectedContactActivitySubjectOptions: this.selectedContactActivitySubjectOptions,
                selectedBidDate: this.selectedBidDate,
                selectedBidDateArray: this.selectedBidDateArray
            }).then((response) => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.checkSelectedCalendar('afterSync');
                this.syncIcon = false;
            });
        },
        getContactSalesBehaviors(){
            axios.get(route('settings.contact-behavior.for-calendar-sync')).then((response) => {
                this.selectedContactBehaviourOptions = response.data.map(contactBehaviorObj => {
                    return ({
                        value: contactBehaviorObj.id,
                        text: contactBehaviorObj.name
                    });
                });

                let followupObj = {
                    value: -1,
                    text: 'Follow Up'
                };

                this.selectedContactBehaviourOptions.push(followupObj);
            });
        },
        getEventSubject(){
            axios.get(route('calendar.get-calendar-event-subject-options')).then((response) => {
                this.salesActivitySubjectOptions = response.data.salesActivitySubjectOption;
                this.contactActivitySubjectOptions = response.data.contactActivitySubjectOption;
                this.bidDateSubjectOption = response.data.bidDateSubjectOption;
                this.preBidDateSubjectOption = response.data.preBidDateSubjectOption;
                this.getUserSelectedEventSettings();
            });
        },
        saveCalendarSettings(from = null){
            let data = {
                'subjects': {
                    selectedSalesActivitySubjectOptions: this.selectedSalesActivitySubjectOptions,
                    selectedContactActivitySubjectOptions: this.selectedContactActivitySubjectOptions,
                    selectedBidDateSubjectOption: this.selectedBidDateSubjectOption,
                    selectedPreBidDateSubjectOption: this.selectedPreBidDateSubjectOption
                },
                'behaviors': {
                    selectedSalesValue: this.selectedSalesValue,
                    selectedContactValue: this.selectedContactValue,
                    selectedBidDate: this.selectedBidDate,
                    selectedBidDateArray: this.selectedBidDateArray,
                }
            };
            axios.post(route('calendar.save-calendar-event-options'), data).then((response) => {
                if(!from){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }
            });
        },
        getUserSelectedEventSettings(){
            axios.post(route('calendar.get-calendar-event-settings')).then((response) => {
                if(response.data.calendar_behaviors != null && response.data.calendar_behaviors != ''){
                    let behaviorData = JSON.parse(response.data.calendar_behaviors);
                    this.selectedSalesValue = behaviorData.selectedSalesValue;
                    this.selectedContactValue = behaviorData.selectedContactValue;
                    this.selectedBidDate = behaviorData.selectedBidDate;
                    this.selectedBidDateArray = (behaviorData.selectedBidDateArray)? behaviorData.selectedBidDateArray:[];
                }

                if(response.data.calendar_event_subject != null && response.data.calendar_event_subject != ''){
                    let subjectData = JSON.parse(response.data.calendar_event_subject);
                    this.selectedContactActivitySubjectOptions = subjectData.selectedContactActivitySubjectOptions;
                    this.selectedSalesActivitySubjectOptions = subjectData.selectedSalesActivitySubjectOptions;
                    this.selectedBidDateSubjectOption = subjectData.selectedBidDateSubjectOption;
                    this.selectedPreBidDateSubjectOption = subjectData.selectedPreBidDateSubjectOption;
                }
            });
        },
        unsyncCalendarSettings(connectionStatus = 1){
            this.unsyncIcon = true;
            axios.post(route('calendar.unsync-calendar'), {
                calendar: this.selectedCalendar,
                connectionStatus: connectionStatus
            }).then((response) => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.unsyncIcon = false;
                this.checkSelectedCalendar('afterSync');
            });
        },
        reauthenticateUser(){
            Swal.fire({
                title: 'Re-Authenticate Email',
                text: "Do you want to re-authenticate email, this will disconnect your external email.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Continue re-authenticating!'
            }).then((result) => {
                if (result.value) {
                    this.emptyUserSelectedCalendarWhenDisconnect();
                    if(this.user.external_email && this.user.external_email_service != 'nylas'){
                        axios.get(route('external-email.signout')).then((response) => {
                            window.location.href = "/settings";
                        });
                    }else if(this.user.external_email && this.user.external_email_service == 'nylas'){
                        axios.get(route('disconnect-nylas')).then((response) => {
                            window.location.href = "/settings";
                        });
                    }
                }
            });
        },
        emptyUserSelectedCalendarWhenDisconnect(){
            axios.post(route('calendar.empty-selected-calendar'), {user: this.user}).then((response) => {
                window.location.href = "/settings";
            });
        },
        makeItToolTip(){
            setTimeout(() => {
                $('.makeItTooltip').tooltip();
                this.makeItToolTip();
            }, 3000);
        }
    }
}
</script>
<style>
    .form-control:focus{
        border-color: #b9c2cc;
    }
    .min-width-custom-calendar{
        min-width: 350px;
    }
    .custom-calendar-input-padding{
        padding: 18px 10px;
    }
    .custom-calendar-checkbox > div{
        min-width: 230px;
    }
    .custom-calendar-checkbox .custom-checkbox{
        word-break: break-word;
        width: 25%;
    }
</style>
